export default __webpack_public_path__ + "static/media/color_picker.f9d95c25.png";